module.exports = __webpack_public_path__ + "media/customizations/paintedtree/logo-c272bf507a8e25e4cff0bb66712786bc.png";